

const { ccclass, property, menu, disallowMultiple } = cc._decorator;

/**
 * 节点振动
 */
@ccclass
@disallowMultiple
@menu('Framework/UI组件/ShakeNode')
export default class ShakeNode extends cc.Component {
	@property({ tooltip: CC_DEV && '振动幅度' })
	public ShakePower: number = 5;

	@property({ tooltip: CC_DEV && '振动周期，单位：秒' })
	public ShakeTime: number = 0.16;

	private bPlaying: boolean = false;

	/**
	 * 振动
	 * @param times 振动几个周期
	 */
	public shake(times: number = 5) {
		if (this.bPlaying || times <= 0 || this.ShakePower <= 0 || this.ShakeTime <= 0) {
			return;
		}

		this.bPlaying = true;
		let oriPos = this.node.getPosition();
		let length = 8;
		let sv = cc.v2(0, this.ShakePower);
		// this.node.setPosition(sv);

		let xArr: number[] = [];
		let yArr: number[] = [];

		for (let i = 1; i <= length; i++) {
			let v = cc.v2(sv).rotate(Math.PI / 4 * (i * 3));
			xArr.push(v.x);
			yArr.push(v.y);
		}

		let n = 0;
		let t = this.ShakeTime / length;
		let countNum = length * times;
		for (let i = 0; i < countNum; i++) {
			let idx = i % length;
			// let r = Math.floor(i / length);
			cc.tween(this.node)
				.delay(i * t)
				.by(t, { x: xArr[idx], y: yArr[idx] })
				.call(() => {
					n++;
					if (n >= countNum) {
						this.bPlaying = false;
						this.node.setPosition(oriPos);
					}
				})
				.start();
		}

	}
}
